import React, { useState } from "react";
import { Nav } from "react-bootstrap";
import { withRouter } from "react-router";
import { NavLink } from "react-router-dom";
import "../_scss/Sidebar.scss";
import { ModalPopup } from "../../AdminTool/ModalPopup/ModalPopup";
const iconPath = process.env.PUBLIC_URL + "/icons/";
const Side = props => {

    const [showModal, setModalState] = useState(false);
    const [showConfigLink,setShowConfigLink] = useState(false)
    const closeSideBar = () => {
        props.onUpdate(!props.showSideBar);
        // $("#sideMenubar").slideToggle();
    };


    function logoutHandler() {
        setModalState(true);
    }
    function triggerLogout() {
        setModalState(false);
        closeSideBar();
        localStorage.clear();
        props.auth.logout();
    }

    const expandCollapse =() =>{
        setShowConfigLink(!showConfigLink)
    }
    return (
        <>
            <div className="side-menu-container">
                <Nav
                    className="d-none d-md-block sidebar"
                    activeKey="/home"
                //   onSelect={selectedKey => alert(`selected ${selectedKey}`)}
                >
                    <div className="row sidebar-title">
                        <div className="col-lg-8 sidebar-text-container">
                            <div className="sidebar-text">
                              
                                <span className="app-title">One MB</span>
                            </div>
                        </div>
                        <div className="col-lg-4 close-sidebar-container">
                            <span className="close-sidebar" onClick={closeSideBar}>
                                X
              </span>
                        </div>
                    </div>

                    {props.auth.roleScopes && props.auth.roleScopes.includes('configtool') ?
                        <Nav.Item>
                            <div className="icon">
                                <img src={`${iconPath}update.png`}></img>
                            </div>
                            <div className="link">
                                {/* <Nav.Link href="/configTool">Configuration Tool</Nav.Link> */}
                                <p onClick={expandCollapse}>Configuration Tool</p>
                            </div>
                        </Nav.Item> : ""}
                        {showConfigLink &&
                        <div className="admin-config-links">
                            <Nav.Item>
                                <div className="icon">
                                    <img src={`${iconPath}update.png`}></img>
                                </div>
                                <div className="link">
                                    {/* <Nav.Link href="/configTool">Configuration Tool</Nav.Link> */}
                                    <NavLink to="/configTool/groups" onClick={closeSideBar}>Groups</NavLink>
                                </div>
                            </Nav.Item>

                            <Nav.Item>
                                <div className="icon">
                                    <img src={`${iconPath}update.png`}></img>
                                </div>
                                <div className="link">
                                    {/* <Nav.Link href="/configTool">Configuration Tool</Nav.Link> */}
                                    <NavLink to="/configTool/roles" onClick={closeSideBar}>Roles</NavLink>
                                </div>
                            </Nav.Item>
                        </div>
                        }


                    {/* <Nav.Item>
                        <div className="icon">
                            <img src={`${iconPath}new.png`}></img>
                        </div>
                        <div className="link">
                            <NavLink to="/dashboard" onClick={closeSideBar}>What's New</NavLink>
                        </div>
                    </Nav.Item>
                    <Nav.Item>
                        <div className="icon">
                            <img src={`${iconPath}help.png`}></img>
                        </div>
                        <div className="link">
                            <NavLink to="/dashboard" onClick={closeSideBar}>Help & feedback</NavLink>
                        </div>
                    </Nav.Item>
                    <Nav.Item>
                        <div className="icon">
                            <img src={`${iconPath}settings.png`}></img>
                        </div>
                        <div className="link">
                            <NavLink to="/dashboard" onClick={closeSideBar}>Settings</NavLink>
                        </div>
                    </Nav.Item> */}
                  
                        <Nav.Item>
                            <div className="icon logout-icon">
                                <img src={`${iconPath}log_out.png`}></img>
                            </div>
                            <div className="link ">
                                {/* <Nav.Link href="/home">Logout</Nav.Link> */}
                                <a onClick={logoutHandler}>Logout</a>
                            </div>
                        </Nav.Item>
                    
                </Nav>
            </div>
            <ModalPopup show={showModal} onHide={() => setModalState(false)} title="Logout" message="Do you want to logout?" actionlabel="Yes" onUpdateToParent={triggerLogout} />
        </>
    );
};
const Sidebar = withRouter(Side);
export default Sidebar;
